import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-69eab808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attention" }
const _hoisted_2 = { class: "confirm" }

import {ref} from "vue";
import {useRoute} from "vue-router";
import {Guild} from "@/types/Guild";
import config from "@/config.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetBalance',
  props: {
    guild: {}
  },
  setup(__props: any) {

const props = __props
let guild = props.guild;
let dialog = ref(false)
let loading = ref(false)
let name = ref();

async function reset() {
  loading.value = true;
  let response = await fetch(`${config.API}/private/guilds/${guild.id}/reset`, {
    method: 'POST',
    headers: {
      Authorization: localStorage.getItem('token') as string,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name: name.value,
      scopes: ['balance']
    })
  })
  if(response.ok) dialog.value = false;
  loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn, {
      color: "red",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = true : dialog = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('ResetBalance.reset')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(dialog),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
      width: "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('ResetBalance.resetBalance')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('ResetBalance.attention')), 1),
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('ResetBalance.confirm')), 1),
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(name),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(name) ? (name).value = $event : name = $event)),
                  class: "mt-3",
                  color: "red",
                  label: _ctx.$t('ResetBalance.name'),
                  placeholder: _unref(guild).name,
                  variant: "outlined"
                }, null, 8, ["modelValue", "label", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "red",
                  onClick: reset,
                  disabled: _unref(name) !== _unref(guild).name,
                  loading: _unref(loading),
                  text: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('ResetBalance.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]),
                _createVNode(_component_v_btn, {
                  text: "",
                  disabled: _unref(loading),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = false : dialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('ResetBalance.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})